import { HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { helpers } from 'chart.js';
import { appConfigs } from '../constants/initialize';

export class HelperService {

    constructor() {
    }

    static options(): HttpHeaders {
        return new HttpHeaders({
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Api-Client': environment.apiClient,
            'Api-Key': environment.apiKey,
            'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
        });
    }
    static optionsFormData(): HttpHeaders {
        return new HttpHeaders({
            Accept: 'multipart/form-data',
            'Content-Type': 'multipart/form-data',
            'Api-Client': environment.apiClient,
            'Api-Key': environment.apiKey,
            'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
        });
    }

    static formatDate(date): string {
        if (date !== undefined) {
            return new Date(date).toJSON().split('T')[0];
        }
        return appConfigs.empty;
    }

    static getFormData(object): FormData {
        const formData = new FormData();
        Object.keys(object).forEach(key => formData.append(key, object[key]));
        return formData;
    }
    static cleanFormatSocialLink(valueToClean: string): string {
        return valueToClean.replace(appConfigs.phoneFormat, appConfigs.empty)
            .replace(appConfigs.whatsappFormatUrl, appConfigs.empty)
            .replace(appConfigs.whatsappFormatText, appConfigs.empty)
            .replace(appConfigs.facebookFormatUrl, appConfigs.empty)
            .replace(appConfigs.instagramFormatUrl, appConfigs.empty);
    }
    static myRoles(): string[] {
        let roles: string[];
        if (localStorage.getItem('user')) {
            const user = JSON.parse(localStorage.getItem('user'));
            roles = user.my_roles;
        }
        return roles;
    }
    static checkAbilitiesInRol(ability: string): boolean {
        if (localStorage.getItem('user')) {
            const user = JSON.parse(localStorage.getItem('user'));
            if (! user.my_permission.includes(ability)) {
               return false;
            }
        }
        return true;
    }
    static checkIsSeller(): boolean {
        let roles: string[];
        if (localStorage.getItem('user')) {
            const user = JSON.parse(localStorage.getItem('user'));
            roles = user.my_roles;
        }

        return roles.includes(appConfigs.roleSeller) && !roles.includes(appConfigs.roleAdmin);
    }
}
